import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings.js";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const ThreeColumn = tw.div`flex flex-wrap`;
const Column = tw.div``;
const HeadingColumn = tw(Column)`w-full xl:w-1/3`;

const HeadingInfoContainer = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-10 mb-10 xl:mb-0 xl:px-10 xl:h-96 bg-secondary-500`;
const HeadingInfoContainerAltColor = tw(HeadingInfoContainer)`bg-secondary-100`;
const HeadingTitle = tw(SectionHeading)`leading-tight text-3xl font-medium p-4 align-middle text-white`;
const HeadingDescription = tw.p`text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 xl:mt-8 p-10 pt-0 xl:p-0 text-center`;
const HeadingDescriptionAltColor = tw(HeadingDescription)`text-secondary-500`;

export default () => {
  return (
    <Container>
      <Content>
        <ThreeColumn>
          <HeadingColumn>
            <HeadingInfoContainer>
              <HeadingTitle>Student Support</HeadingTitle>
              <HeadingDescription>
              Positive Behavior Interventions and Support, Campus Art, Classroom and Teacher Support & Supplies, Cultural Arts, Field Day, Student Contests and Awards, Student Enrichment Programs, Literacy Program
              </HeadingDescription>
            </HeadingInfoContainer>
          </HeadingColumn>
          <HeadingColumn>
            <HeadingInfoContainerAltColor>
              <HeadingTitle>Campus Support</HeadingTitle>
              <HeadingDescriptionAltColor>
              Walking Paths, Greenhouse and Garden, Playground Equipment, Administrative Support, Classroom Technology & Supplies
              </HeadingDescriptionAltColor>
            </HeadingInfoContainerAltColor>
          </HeadingColumn>
          <HeadingColumn>
            <HeadingInfoContainer>
              <HeadingTitle>Faculty & Staff Support</HeadingTitle>
              <HeadingDescription>
              Teacher Treats, Classroom First Aid Kits, Red Ribbon Week, Pull-out Supplies, Teacher Morale Events, Workroom Supplies, Teacher Welcome Back Lunch, Hospitality Appreciations
              </HeadingDescription>
            </HeadingInfoContainer>
          </HeadingColumn>
        </ThreeColumn>
      </Content>
    </Container>
  );
};
